import TableOfContents, { Item } from './TableOfContents';
import SideTableOfContents from './SideTableOfContents';
import { scrollWithOffset } from './utils';
import Anchor from './Anchor';

export type { Item };
export { Anchor, SideTableOfContents, scrollWithOffset };
export default TableOfContents;
